import { Switch, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import PrivateRoute from "./PrivateRoute";
//main
import Dashbord from "../views/backend/main/dashbord";
import Sliders from "../views/backend/main/sliders";

//Movie
import AddMovie from "../views/backend/movie/add-movie";
import MovieList from "../views/backend/movie/movie-list";
import UpdateMovie from "../views/backend/movie/UpdateMovie";
import ViewMovie from "../views/backend/movie/movie-info";

//Show
import AddShow from "../views/backend/show/add-show";
import ShowList from "../views/backend/show/show-list";
import UpdateShow from "../views/backend/show/UpdateShow";
import EpisodeList from "../views/backend/show/episode-list";
import ViewShow from "../views/backend/show/show-info";
import ViewEpisode from "../views/backend/show/episode-info";
// genre
import AddGenre from "../views/backend/genre/AddGenre";
import CategoryList from "../views/backend/genre/CategoryList";
import updateCategory from "../views/backend/genre/updateCategory";
// video

// podcast
import AddPodcast from "../views/backend/podcast/add-podcast";
import PodcastList from "../views/backend/podcast/podcast-list";
import UpdatePodcast from "../views/backend/podcast/UpdatePodcast";
import ViewPodcast from "../views/backend/podcast/podcast-info";
import PodcastEpisodeList from "../views/backend/podcast/podcast-episode-list";
import ViewPodcastEpisode from "../views/backend/podcast/podcast-episode-info";
import PodcastDistribution from "../views/backend/podcast/distribution";
// channels
import AddChannel from "../views/backend/channels/add-channel";
import ChannelList from "../views/backend/channels/channel-list";
import UpdateChannel from "../views/backend/channels/UpdateChannel";

import UserList from "../views/backend/users/user-list";
import ActiveUsers from "../views/backend/users/ActiveUsers";
import Quiz from "../views/backend/quiz/Quiz";
import Revenue from "../views/backend/revenue/Revenue";
import Comeback from "../views/backend/users/Comeback";
import VideoPerformance from "../views/backend/video-performance/VideoPerformance";
import CategoryStats from "../views/backend/category-stats/CategoryStats";
import CategoryDetail from "../views/backend/category-stats/CategoryDetail";
import Lives from "../views/backend/lives/Lives";
import Emails from "../views/backend/emails/Emails";
import Incidents from "../views/backend/incidents/Incidents";
import UserInfo from "../views/backend/users/user-info";
import AdminList from "../views/backend/admin/admin-list";
import PaymentGateway from "../views/backend/payment/payment-gateway";
import Broadcast from "../views/backend/broadcast/broadcast";
import MyBroadcast from "../views/backend/broadcast/my-broadcast";
import BroadcastInfo from "../views/backend/broadcast/broadcast-info";
import Notifications from "../views/backend/notifications/notifications";
import Logs from "../views/backend/logs/logs";
import Dunning from "../views/backend/dunning/Dunning";
import MobileApp from "../views/backend/mobile-app/MobileApp";
import Payments from "../views/backend/payments-ledger/Payments";
import Maintenance from "../views/backend/maintenance/Maintenance";
import Comments from "../views/backend/comments/Comments";
import Terms from "../views/backend/terms-conditions/terms";
import Privacy from "../views/backend/privacy-policy/privacy";
import FAQS from "../views/backend/faqs/faqs";
import UserProfile from "../views/backend/auth/UserProfile";
import Package from "../views/backend/pricing/pricing";
import Analytics from "../views/backend/Analytics/Analytics";
import AboutUs from "../views/backend/about-us/AboutUs";
import SocialChannels from "../views/backend/social-channels/social-channels";
import createAds from "../views/backend/ads/create-ads";
import updateAds from "../views/backend/ads/update-ads";
import AdsList from "../views/backend/ads/ads-list";
import ViewAds from "../views/backend/ads/ads-info";
import PagesPermissions from "../views/backend/routes-permission/RoutesPermissions";
const Layout1Route = () => {
  let location = useLocation();

  return (
    <TransitionGroup>
      <CSSTransition key={location.key} classNames="fade" timeout={300}>
        <Switch location={location}>
          {/* <Route path="/sliders" exact component={Sliders} /> */}
          <PrivateRoute
            path="/dashboard/sliders"
            component={Sliders}
            section="sliders"
            level="edit"
          />
          {/* <Route path="/dashboard" exact component={Dashbord} /> */}

          {/* Movie */}
          {/* <Route path="/add-movie" component={AddMovie} /> */}
          {/* <Route path="/movie-list" component={MovieList} /> */}
          {/* <Route path="/update-movie" component={UpdateMovie} /> */}
          <PrivateRoute
            path="/dashboard/add-video"
            component={AddMovie}
            section="videos"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/video-list"
            component={MovieList}
            section="videos"
          />
          <PrivateRoute
            path="/dashboard/update-video/:video_id"
            component={UpdateMovie}
            section="videos"
            level="edit"
          />

          <PrivateRoute
            path="/dashboard/video-info/:videoInfo_id"
            component={ViewMovie}
            section="videos"
          />
          {/* ADS */}
          <PrivateRoute
            path="/dashboard/create-ads"
            component={createAds}
            section="ads"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/update-ad/:ad_id"
            component={updateAds}
            section="ads"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/ads-list"
            component={AdsList}
            section="ads"
          />
          <PrivateRoute
            path="/dashboard/ad-info/:ad_id"
            component={ViewAds}
            section="ads"
          />

          {/*-================================ Show ======================================= */}
          {/* <Route path="/add-show" component={AddShow} /> */}
          {/* <Route path="/show-list" component={ShowList} /> */}
          {/* <Route path="/update-show/:tvshow_id" component={UpdateShow} /> */}
          {/* <Route path="/episode-info" component={ViewEpisode} /> */}
          {/* <Route path="/episode-list/:show_id" component={EpisodeList} /> */}
          <PrivateRoute
            path="/dashboard/add-show"
            component={AddShow}
            section="series"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/show-list"
            component={ShowList}
            section="series"
          />
          <PrivateRoute
            path="/dashboard/update-show/:tvshow_id"
            component={UpdateShow}
            section="series"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/show-info/:tvshow_id"
            component={ViewShow}
            section="series"
          />
          <PrivateRoute
            path="/dashboard/episode-info/:episodeInfo_id"
            component={ViewEpisode}
            section="series"
          />
          <PrivateRoute
            path="/dashboard/episode-list/:show_id"
            component={EpisodeList}
            section="series"
          />
          {/* ==============================genre================================= */}
          {/* <Route path="/add-genre" component={AddGenre} />
          <Route path="/category-list" component={CategoryList} />
          <Route path="/update-category" component={updateCategory} /> */}
          <PrivateRoute
            path="/dashboard/add-genre"
            component={AddGenre}
            section="categories"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/category-list"
            component={CategoryList}
            section="categories"
          />
          <PrivateRoute
            path="/dashboard/update-category"
            component={updateCategory}
            section="categories"
            level="edit"
          />
          {/* ==================================podcast ========================  */}
          {/* <Route path="/add-podcast" component={AddPodcast} />
          <Route path="/podcast-list" component={PodcastList} /> */}
          {/* <Route
            path="/podcast-episode-list/:podcast_id"
            component={PodcastEpisodeList}
          /> */}
          <PrivateRoute
            path="/dashboard/add-podcast"
            component={AddPodcast}
            section="podcasts"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/podcast-distribution"
            component={PodcastDistribution}
            section="podcasts"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/podcast-list"
            component={PodcastList}
            section="podcasts"
          />
          <PrivateRoute
            path="/dashboard/update-podcast/:podcast_id"
            component={UpdatePodcast}
            section="podcasts"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/podcast-info/:podcast_id"
            component={ViewPodcast}
            section="podcasts"
          />

          <PrivateRoute
            path="/dashboard/podcast-episode-list/:podcast_id"
            component={PodcastEpisodeList}
            section="podcasts"
          />
          <PrivateRoute
            path="/dashboard/podcast-episode-info/:podcastEpisode_id"
            component={ViewPodcastEpisode}
            section="podcasts"
          />
          {/* channels ======================================================= */}
          {/* <Route path="/add-channel" component={AddChannel} />
          <Route path="/channel-list" component={ChannelList} /> */}
          {/* <Route path="/update-channel" component={UpdateChannel} /> */}
          <PrivateRoute
            path="/dashboard/add-channel"
            component={AddChannel}
            section="channels"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/channel-list"
            component={ChannelList}
            section="channels"
          />
          <PrivateRoute
            path="/dashboard/update-channel/:channel_id"
            component={UpdateChannel}
            section="channels"
            level="edit"
          />
          {/* user========== */}
          {/* <Route path="/user-list" component={UserList} /> */}
          {/* <Route path="/user-info" component={UserInfo} /> */}
          <PrivateRoute
            path="/dashboard/user-info"
            component={UserInfo}
            section="users"
          />
          <PrivateRoute
            path="/dashboard/user-list"
            component={UserList}
            section="users"
          />
          <PrivateRoute path="/dashboard/active-users" component={ActiveUsers} section="users" />
          <PrivateRoute path="/dashboard/quiz" component={Quiz} section="quiz" />
          <PrivateRoute path="/dashboard/revenue" component={Revenue} section="transactions" />
          <PrivateRoute path="/dashboard/win-back" component={Comeback} section="users" />
          <PrivateRoute path="/dashboard/video-performance" component={VideoPerformance} section={["videos", "analytics", "dashboard"]} />
          <PrivateRoute path="/dashboard/category-stats/:id" component={CategoryDetail} section={["videos", "analytics", "dashboard", "categories"]} />
          <PrivateRoute path="/dashboard/category-stats" component={CategoryStats} section={["videos", "analytics", "dashboard", "categories"]} />
          <PrivateRoute path="/dashboard/lives" component={Lives} section={["channels", "dashboard", "analytics"]} />
          <PrivateRoute path="/dashboard/emails" component={Emails} section={["users", "logs"]} />
          <PrivateRoute path="/dashboard/incidents" component={Incidents} section="logs" />
          {/* =========================== broadcast ======================== */}
          <PrivateRoute
            path="/dashboard/new-broadcast"
            component={Broadcast}
            section="broadcast"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/my-broadcast"
            component={MyBroadcast}
            section="broadcast"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/broadcast-info/:broadcast_id"
            component={BroadcastInfo}
            section="broadcast"
            level="edit"
          />
          {/* =========================== notifications ======================== */}
          <PrivateRoute
            path="/dashboard/notifications"
            component={Notifications}
            section="notifications"
            level="edit"
          />
          {/* =========================== logs ======================== */}
          <PrivateRoute
            path="/dashboard/logs"
            component={Logs}
            section={["logs", "admins"]}
          />
          {/* =========================== payments (donations, subscriptions, purchases) ======================== */}
          <PrivateRoute path="/dashboard/payments" component={Payments} section="transactions" />
          {/* =========================== unpaid reminders (manual, on top of the automatic ones) ======================== */}
          <PrivateRoute path="/dashboard/unpaid-reminders" component={Dunning} section="transactions" />
          {/* =========================== mobile app (Firestore configuration, update notification) ======================== */}
          <PrivateRoute path="/dashboard/mobile-app" component={MobileApp} section="mobile_app" />
          {/* =========================== comments (pin, heart, Alain Foka's messages) ======================== */}
          <PrivateRoute path="/dashboard/comments" component={Comments} section="comments" />
          {/* =========================== maintenance (system admins) ======================== */}
          <PrivateRoute
            path="/dashboard/maintenance"
            component={Maintenance}
            section="maintenance"
          />
          {/* ========================= admin ================================= */}
          <PrivateRoute
            path="/dashboard/admin-list"
            component={AdminList}
            section="admins"
            level="edit"
          />
          {/* ================================== payment gateway ====================== */}
          <PrivateRoute
            path="/dashboard/payment-gateway"
            component={PaymentGateway}
            section="payments"
            level="edit"
          />

          {/* ================================T & C ========================== */}
          <PrivateRoute
            path="/dashboard/terms-and-conditions"
            component={Terms}
            section="legal"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/about-us"
            component={AboutUs}
            section="legal"
            level="edit"
          />
          {/* ================================Privacy Policy ========================== */}
          <PrivateRoute
            path="/dashboard/privacy-policy"
            component={Privacy}
            section="legal"
            level="edit"
          />

          {/* ================================FAQS ========================== */}
          <PrivateRoute
            path="/dashboard/faqs"
            component={FAQS}
            section="faqs"
            level="edit"
          />
          {/* ================================SOCIAL CHANNELS ========================== */}
          <PrivateRoute
            path="/dashboard/social-channels"
            component={SocialChannels}
            section="legal"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/routes-permission"
            component={PagesPermissions}
            section="app_menu"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/profile"
            component={UserProfile}
          />
          <PrivateRoute
            path="/dashboard/package"
            component={Package}
            section="plans"
            level="edit"
          />
          <PrivateRoute
            path="/dashboard/analytics"
            component={Analytics}
            section="analytics"
          />

          {/* ====================== dashboard ========================= */}
          <PrivateRoute
            path="/dashboard"
            component={Dashbord}
            section="dashboard"
          />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default Layout1Route;
